import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

/**
 * Lectura suave de variación (S3). Solo si efCoreEnabled.
 * Mismo estilo glass-card; sin semáforos clínicos.
 */
export default function FunctionalEvolutionCard() {
    const [state, setState] = useState({ loading: true, enabled: false, data: null, error: '' });

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const st = await api.getFunctionalStateStatus();
                const enabled = Boolean(st?.data?.efCoreEnabled);
                if (!enabled) {
                    if (!cancelled) setState({ loading: false, enabled: false, data: null, error: '' });
                    return;
                }
                const evo = await api.getFunctionalEvolution();
                if (!cancelled) {
                    setState({ loading: false, enabled: true, data: evo?.data ?? evo, error: '' });
                }
            } catch (err) {
                if (!cancelled) {
                    setState({ loading: false, enabled: false, data: null, error: '' });
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (state.loading || !state.enabled) return null;

    const d = state.data;
    if (!d?.hasBaseline) {
        return (
            <div className="glass-card" style={{ padding: '1.25rem', marginBottom: '1.25rem' }}>
                <h2 style={{ fontSize: '1.05rem', fontWeight: 600, margin: '0 0 0.5rem' }}>Tu referencia</h2>
                <p className="text-muted" style={{ margin: 0, lineHeight: 1.5, fontSize: '0.95rem' }}>
                    Aún no hay una referencia de acompañamiento. Puedes crearla al renovar el registro de manada
                    (paso opcional).
                </p>
            </div>
        );
    }

    const label = d.trajectory?.label || 'En observación';
    const conf = d.latest?.confidence != null ? Math.round(d.latest.confidence * 100) : null;

    return (
        <div className="glass-card" style={{ padding: '1.25rem', marginBottom: '1.25rem' }}>
            <h2 style={{ fontSize: '1.05rem', fontWeight: 600, margin: '0 0 0.5rem' }}>Variación en el tiempo</h2>
            <p style={{ margin: '0 0 0.5rem', lineHeight: 1.5, color: '#334155' }}>
                Lectura: <strong>{label}</strong>
                {conf != null ? (
                    <span className="text-muted" style={{ fontWeight: 400 }}>
                        {' '}
                        · confianza aprox. {conf}%
                    </span>
                ) : null}
            </p>
            <p className="text-muted" style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.45 }}>
                No es un juicio ni un diagnóstico: compara tu momento actual con tu propia referencia. Si algo
                cambia, es una invitación a conversar con calma.
            </p>
        </div>
    );
}
